import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import darajaLogo from "@/assets/images/darajaLogo.svg";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const [accessibilityOpen, setAccessibilityOpen] = useState(false);

  return (
    <>
      <div className="w-full bg-neutral-100 px-20 py-4 text-sm text-neutral-700">
        <span className="font-semibold">{t("components.footer.links.accessibility")}:</span>

        <span>
          {" "}
          {t("components.footer.message")}{" "}
          <a
            href="mailto:accessibility@mcfoundation.org"
            className="text-[var(--color-brand)] hover:underline"
          >
            accessibility@mcfoundation.org
          </a>
        </span>
      </div>

      <footer className="relative z-[999] w-full border-t border-neutral-700 bg-neutral-900 text-white">
        {/* <AccessibilityPanel open={accessibilityOpen} onClose={() => setAccessibilityOpen(false)} /> */}

        <div className="mx-auto flex max-w-screen-2xl items-center justify-between px-20 py-6">
          <img
            src={darajaLogo}
            alt={t("components.footer.logoAlt")}
            className="h-10 w-auto cursor-pointer"
            onClick={() => navigate("/", { replace: true })}
          />

          <nav className="flex flex-wrap gap-8 text-sm text-neutral-300">
            {/* Accessibility → hover only */}
            {/* <a href="#" className="hover:text-white" onClick={() => setAccessibilityOpen(true)}>
              {t("components.footer.links.accessibility")}
            </a> */}
            <div className="relative group cursor-not-allowed">
              <span className="hover:text-white">{t("components.footer.links.accessibility")}</span>
              <div className="absolute left-1/2 top-full z-10 mt-2 hidden -translate-x-1/2 whitespace-nowrap rounded bg-black px-3 py-1 text-xs text-white group-hover:block">
                Page Coming Soon
              </div>
            </div>

            {/* Privacy Statement (still clickable) */}
            <a
              href="https://mastercardfdn.org/en/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              Privacy Statement
            </a>

            {/* Safeguarding (clickable external link) */}
            <a
              href="https://cdn.buttercms.com/YefbC9GvRMCcH6pSjkzv"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              {t("components.footer.links.safeguarding")}
            </a>

            {/* Terms & Conditions → hover only */}
            {/* <div className="relative group cursor-not-allowed">
              <span className="hover:text-white">
                {t("components.footer.links.termsAndConditions")}
              </span>
              <div className="absolute left-1/2 top-full z-10 mt-2 hidden -translate-x-1/2 whitespace-nowrap rounded bg-black px-3 py-1 text-xs text-white group-hover:block">
                Page Coming Soon
              </div>
            </div> */}
          </nav>
          <span className="text-neutral-400 text-sm">{t("components.footer.copyright")}</span>
        </div>
      </footer>
    </>
  );
}
